import {http} from './request.js';

// const apiUrl = location.protocol+'//192.168.0.138:5020/'
const apiUrl = location.protocol+'//'+location.hostname+':5020/'
const webUrl = '域名'
// const SI=1

const api= {

    //获取url补充静态资源
    getUrl(){
        return webUrl;
    },

    //获取气象站状态
    getState(id=1){
        let data = {"SI":id}
        return http(apiUrl + 'display', data,'POST');
    },
    //获取气象站列表
    getList(){
        return http(apiUrl + 'list_station', {},'POST');
    },
}

export default api

